import AWS from 'aws-sdk';

export const configureAWS = () => {
  AWS.config.region = 'ap-south-1'; // e.g., 'us-east-1'
  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: 'ap-south-1:f6278377-7dcf-4f1b-85ab-9006269a8410'
  });

  AWS.config.credentials.get((err) => {
    if (err) console.log('Error getting credentials:', err);
    // else console.log('Successfully obtained credentials');
  });
};